import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import SaveIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class FormCategory extends Component {
  static propTypes = {
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,

    close: PropTypes.func,
    open: PropTypes.bool,

    category: PropTypes.object,
    factor: PropTypes.object,

    createCategory: PropTypes.func,
    updateCategory: PropTypes.func,
    deleteCategory: PropTypes.func,
    refresh: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      name: "",
      order: "",
      lowExplanation: "",
      midExplanation: "",
      highExplanation: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.init(nextProps.category);
    }
  }

  handleChange = (name) => (event) => {
    const { target } = event;
    const { value } = target;

    this.setState({
      [name]: value,
    });
  };

  handleCheckboxChange = (name) => (event) => {
    const { target } = event;
    const { checked } = target;

    this.setState({
      [name]: checked,
    });
  };

  init(category) {
    this.setState({
      loading: false,
      name: category ? category.name : "",
      description: category ? category.description : "",
    });
  }

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: "Are you sure ?",
        subtitle:
          "If you delete this category, you won't be able to recover it.",
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: "Cancel",
          level: "default",
          callback: () => console.log("Callback"),
        },
        confirm: {
          label: "I am sure",
          level: "error",
          callback: this.confirmDelete.bind(this),
        },
      }
    );
  }

  async confirmDelete() {
    const { deleteCategory, close, refresh, category } = this.props;

    const { NotificationCenter } = this.context;
    close();
    const resp = await deleteCategory(category.id);
    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: "Category has been deleted.",
        success: true,
        timestamp: new Date().getTime(),
      });
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  async save() {
    const {
      updateCategory,
      createCategory,
      factor,
      category,
      refresh,
      close,
    } = this.props;

    const {
      name,
      description,
      highQualifierName,
      lowQualifierName,
      lowExplanation,
      midExplanation,
      highExplanation,
      order,
    } = this.state;

    const { NotificationCenter } = this.context;

    let resp;
    this.setState({ loading: true });
    if (category) {
      resp = await updateCategory(category.id, {
        name,
        description,
        order: order.length === 0 ? undefined : Number(order),
      });
    } else {
      resp = await createCategory({
        factorID: factor.id,
        name,
        description,
        highQualifierName,
        lowQualifierName,
        lowExplanation,
        midExplanation,
        highExplanation,
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: category
          ? "Category has been updated."
          : "Category has been created.",
        success: true,
        timestamp: new Date().getTime(),
      });

      close();
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  render() {
    const { classes, fullScreen, open, category, close } = this.props;

    const {
      name,
      description,
      highQualifierName,
      lowQualifierName,
      lowExplanation,
      midExplanation,
      highExplanation,
      loading,
    } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        onClose={close}
        aria-labelledby="responsive-dialog-title"
      >
        {loading ? (
          <div className={classes.progressContainer}>
            <DialogTitle id="alert-dialog-title">Loading</DialogTitle>
            <CircularProgress />
          </div>
        ) : (
          <div>
            <DialogTitle id="responsive-dialog-title">
              {category ? `${category.name}` : "Let's Create a New Category"}
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    id="category"
                    label="Category"
                    className={classes.textField}
                    value={name}
                    onChange={this.handleChange("name")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="description"
                    label="Description"
                    className={classes.textField}
                    value={description}
                    onChange={this.handleChange("description")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="highQualifierName"
                    label="+ High Qualifier"
                    className={classes.textField}
                    value={highQualifierName}
                    onChange={this.handleChange("highQualifierName")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="lowQualifierName"
                    label="- Low Qualifier"
                    className={classes.textField}
                    value={lowQualifierName}
                    onChange={this.handleChange("lowQualifierName")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="lowExplanation"
                    label="Low Expanation"
                    className={classes.textField}
                    value={lowExplanation}
                    onChange={this.handleChange("lowExplanation")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="midExplanation"
                    label="Mid Explanation"
                    className={classes.textField}
                    value={midExplanation}
                    onChange={this.handleChange("midExplanation")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="highExplanation"
                    label="High Explanation"
                    className={classes.textField}
                    value={highExplanation}
                    onChange={this.handleChange("highExplanation")}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              {category && (
                <Button
                  className={classes.delete}
                  onClick={this.delete.bind(this)}
                >
                  <DeleteIcon className={classes.leftIcon} />
                  &nbsp;Delete
                </Button>
              )}
              <Button onClick={close}>
                <CloseIcon className={classes.leftIcon} />
                &nbsp;Close
              </Button>
              <Button color="primary" autoFocus onClick={this.save.bind(this)}>
                <SaveIcon className={classes.leftIcon} />
                {category ? "Save" : "Create"}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormCategory));
